import { InputTextarea } from "primereact/inputtextarea";
import React from "react";
import { useState } from "react";
import { userClient } from "../../network/lib/user";
import { fireSuccessAlert } from "./../../components/utils/Swal";
import { InputText } from "primereact/inputtext";

const NotificationPage = () => {
  const [message, setMessage] = useState("");
  const [title, setTitle] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      title: title,
      message: message,
    };
    userClient.admin.notification.create(formData).then((res) => {
      fireSuccessAlert("Notification created");
    });
  };

  return (
    <form className="flex-column admin-email-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="admin-email-title">Titre</label>

        <InputText
          id="admin-email-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label htmlFor="admin-email-message">Message</label>
        <InputTextarea
          id="admin-email-message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={5}
          cols={30}
        />
      </div>
      <div className="form-group">
        <button type="submit" className="primary">
          Envoyer
        </button>
      </div>
    </form>
  );
};

export default NotificationPage;
